module.exports = __webpack_public_path__ + "img/circle.bb9fbfe0.svg";